import React from "react";
import {InactiveCourierWalletsTab} from "../courierWalletListPage/inactiveCourierWalletsTab/InactiveCourierWalletsTab";

export const InactiveCourierWalletListPage = () => {
    return (
        <>
            <h1>İnaktif Kurye Cüzdanları</h1>
            <InactiveCourierWalletsTab isTabOpened={true} />
        </>
    );
}; 